// extracted by mini-css-extract-plugin
export default {"image":"CoachCard_image__pNQcW","card":"CoachCard_card__HBm3L","profession":"CoachCard_profession__LVPWy"};